/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { AppService } from '../api.service';
import { WindowService } from './window.service';
import { LocalStorageService } from './localstorage.service';
import { Router } from '@angular/router';
import { ProjectsService } from './project.service';
declare let google: any;
@Injectable({
  providedIn: 'root'
})
export class LocationService {
  is_locations_error=false;
  lattitude: any;
  longitude: any;
  user_location!: { latitude: number; longitude: number; address: any; locality: any; city: any; pincode: any; };
  constructor(private _as:AppService,private window: WindowService,private localStorageService: LocalStorageService,private router:Router, public _project: ProjectsService,){}
  isLoctionLoader=false;
  getPosition(): Promise<any>
  {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resp => {
          resolve({lng: resp.coords.longitude, lat: resp.coords.latitude,formatted:resp.coords});
          // this.isLoctionLoader=false
        },
        err => {
          this.isLoctionLoader=false
          reject(err);
        });
    });
  }

onLocation() {
    this._as.locationPop = true;
    if (!this._as.user_location) {
      setTimeout(() => {
        this.getLocationsSearchByName()
      }, 300);
    }
  }
  updateLocation() {
    if (this._as.isOnMobilePlatform) {
      this._as.locationPop = true;
      this._as.isUpdateLocation = true;
    } else {
      this._as.isUpdateLocation = true;
    }

    setTimeout(() => {
      this.getLocationsSearchByName()
    }, 300);

  }
  changeLocations() {
    if (this._as.isOnMobilePlatform) {
      this._as.locationPop = true;
      this._as.isUpdateLocation = false;
    } else {
      this._as.isUpdateLocation = true;
    }

    setTimeout(() => {
      this.getLocationsSearchByName()
    }, 300);
  }
  getCurrentLocation() {
    this.isLoctionLoader = true;
    this.getPosition().then((pos:any) => {
      this.getAddressbyLatlong(`${pos.lng}`, `${pos.lat}`)
    },(reject:any)=>{
      this.is_locations_error = true;
      console.log("Error in getting location",reject)
      setTimeout(() => {
        this.getLocationsSearchByName()
      }, 300);
    });
  }




  getLocationsSearchByName() {
    
    //----------------- Type 1.2 -------------//
    try{
    const map = new google.maps.Map(
      document.getElementById("usergmap") as HTMLElement,
      {
        center: new google.maps.LatLng(this.lattitude, this.longitude),
        zoom: 3,
      }
    );
    const card = document.getElementById("pac-card") as HTMLElement;
    map.controls[google.maps.ControlPosition.TOP_RIGHT].push(card);

    const center = { lat: this.lattitude, lng: this.longitude };
    const defaultBounds = {
      north: center.lat + 0.1,
      south: center.lat - 0.1,
      east: center.lng + 0.1,
      west: center.lng - 0.1,
    };
    let input: any;
    if (this._as.isOnMobilePlatform) {
      input = document.getElementById("pac-input-mob") as HTMLInputElement;
    }
    else {
      input = document.getElementById("pac-input") as HTMLInputElement;
    }
    const options = {
      bounds: defaultBounds,
      componentRestrictions: { country: "in" },
      fields: ["address_components", "geometry", "icon", "name", "formatted_address"],
      strictBounds: false,
      types: ["establishment"],
    };
    const autocomplete = new google.maps.places.Autocomplete(input, options);
    autocomplete.setComponentRestrictions({
      country: ["us", "pr", "vi", "gu", "mp"],
    });
    autocomplete.setBounds(map.getBounds());
    const infowindow = new google.maps.InfoWindow();
    const infowindowContent = document.getElementById(
      "infowindow-content"
    ) as HTMLElement;
    infowindow.setContent(infowindowContent);

    const marker = new google.maps.Marker({
      map,
      anchorPoint: new google.maps.Point(0, -29),
    });
    autocomplete.addListener("place_changed", () => {
      infowindow.close();
      marker.setVisible(false);

      const place = autocomplete.getPlace();
      if (!place.geometry || !place.geometry.location) {
        const win = this.window.nativeWindow
        if(win){
          win.alert("No details available for input: '" + place.name + "'");
        }
       
        return;
      }

      const myLatLng = place.geometry.location;
      this.lattitude = myLatLng.lat();
      this.longitude = myLatLng.lng();
      const add = place.formatted_address
      const value = add.split(",");
      const count = value.length;
      const address_breckup_list = value[count - 2].split(" ");
      console.log("value: ",value)
      this.user_location = {
        latitude: Number(this.lattitude),
        longitude: Number(this.longitude),
        address: place.formatted_address,
        locality: value[count - 4],
        city: value[count - 3],
        pincode: address_breckup_list[address_breckup_list.length - 1]
      };
      this.localStorageService.setItem('user_location', JSON.stringify(this.user_location));
      this._as.user_location = this.user_location
      if (this._as.isUserLoggedIn) {
        this.saveLocation()
        const url = this._as.router.url;
        if (this._as.router.url.split('/')[1] == 'cart') {
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
            this.router.navigate([url]));
        }
      }
      this.closeChangeLocation()
    });

  }catch{
    console.log("Google map not working")
  }
    //----------------- End Type 1.2 -------------//

  }
  getAddressbyLatlong(lng: any, lat: any) {
    const coords = new google.maps.LatLng(lat, lng);
    const geocoder = new google.maps.Geocoder();
    
    geocoder.geocode({
      'latLng': coords
    }, (results: any, status: any) => {
      if (status == google.maps.GeocoderStatus.OK) {
        if (results[0]) {
          const add = results[0].formatted_address
          const value = add.split(",");
          const count = value.length;
          const address_breckup_list = value[count - 2].split(" ")
          
          this.user_location = {
            latitude: Number(lat),
            longitude: Number(lng),
            address: results[0].formatted_address,
            locality: value[count - 4],
            city: value[count - 3],
            pincode: address_breckup_list[address_breckup_list.length - 1]
          };
          this.isLoctionLoader=false
          this.localStorageService.setItem('user_location', JSON.stringify(this.user_location));
          this._as.user_location = this.user_location
        }
        if (this._as.isUserLoggedIn) {
          this.saveLocation()
        }
        
        this.isLoctionLoader = false;
        this.closeChangeLocation()
      }else{
        console.log("")
        this.is_locations_error = true;
      }
    });
  }
  saveLocation() {
    const data = {
      lat: this._as.user_location.latitude,
      long: this._as.user_location.longitude,
    }
    const url = this._as.api_base_url + 'renovarz/save-location/';
    this._as.postRequest(url, data, true)
      .subscribe();
  }

  closeChangeLocation() {
    this._as.locationPop = false;
    this._as.isUpdateLocation = false;
    if (this._as.isUserLoggedIn) {
       if (this._as.router.url.split('/')[1].split('?')[0] == 'my-list') {
        const project_id = this._project.getProjectId();
        this.router.navigateByUrl('/', { skipLocationChange: true ,onSameUrlNavigation:'reload'}).then(() =>
          this.router.navigate(['my-list'], { queryParams: { fl: 'search', pId: project_id } }))
      }
      if (this._as.router.url.split('/')[1] == 'p') {
        const url = this._as.router.url;
        this.router.navigateByUrl('/', { skipLocationChange: true ,onSameUrlNavigation:'reload'}).then(() =>
        this.router.navigate([url]));
      }
    }else{
      if (this._as.router.url.split('/')[1] == 'p') {
        const url = this._as.router.url;
        this.router.navigateByUrl('/', { skipLocationChange: true ,onSameUrlNavigation:'reload'}).then(() =>
        this.router.navigate([url]));
      }
      this.guestUpdateUser();
    }
  }
  guestUpdateUser(){  
    
    const myuuid = JSON.parse(this.localStorageService.getItem('uuid') || '');
    if(!myuuid){
      return
    }
      const url = this._as.api_base_url + 'renovarz/guest-user/'+myuuid+'/';
      const data = {
        location_data:this._as.user_location
      }
      this._as.putRequest(url, data,true).subscribe(() => {
      // eslint-disable-next-line no-empty
      })
    
}
}
